/** @format */

import TagInputWrapper from './TagInputWrapper';

export default TagInputWrapper;
